import React, { useState, useCallback } from 'react';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  LinearProgress,
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { Alert } from '@mui/material';

import { TableBox } from 'retired/Box';
import { useChaptersQuery } from 'generated/graphql';
import { selectUser } from 'entities/user/selectors';

import AddNewChapterBlock from '../AddNewChapterBlock';

import { NonprofitRow } from './NonprofitRow';

const AcceptedChapters = ({
  openNewChapterModal,
}: {
  openNewChapterModal: (isOpen: boolean) => void;
}) => {
  const user = useSelector(selectUser);

  const { data, loading, error, refetch } = useChaptersQuery({
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache',
  });

  const nonprofits = data?.chapters.filter((nonprofit) => nonprofit !== null) || [];

  const [firstLoad, setFirstLoad] = useState(true);

  const refetchNonprofits = useCallback(() => {
    setFirstLoad(false);
    refetch();
  }, [refetch]);

  const showSpinner = loading && firstLoad;

  return (
    <>
      {showSpinner ? <LinearProgress /> : <div style={{ height: 4 }} />}

      {!showSpinner && (
        <>
          {nonprofits.length > 0 ? (
            <TableBox>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Nonprofit Name</TableCell>
                    <TableCell>Location</TableCell>
                    <TableCell>Affiliation Type</TableCell>
                    {user?.isAdmin && <TableCell>Invisible</TableCell>}
                    <TableCell>Access</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {nonprofits.map((nonprofit) => (
                    <NonprofitRow
                      key={nonprofit.nonprofitId}
                      user={user}
                      nonprofit={nonprofit}
                      refetchNonprofits={refetchNonprofits}
                      loadingChapters={loading}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableBox>
          ) : (
            <AddNewChapterBlock setOpen={openNewChapterModal} />
          )}
        </>
      )}

      {error && <Alert security="error">There was an error loading the data</Alert>}
    </>
  );
};

export default AcceptedChapters;
